<template>
  <div class="register_container bg_register">
    <div class="register_imgLogo"><img src="../assets/images/j-i2.png" alt=""></div>
    <!-- <form action=""> -->
    <div class="register_info">
      <!-- @blur="getIsPhone" -->
      <input type="text" v-model="phone" id="phone" placeholder="请输入手机号">
      <div class="register_yzm">
        <!-- @blur="getIsqrCode" -->
        <input type="text" v-model="qrcode" placeholder="请输入验证码">
        <button @click="buttonStatus" :disabled='disableds' ref="buttonStatus">{{btncontent}}</button>
      </div>
      <!-- @blur ="getIsUsername" @blur ="getIsPassword" @blur ="getIsAgainpassword"-->
      <input type="text" id='name' v-model="username" class="clearfix" placeholder="请输入用户名">
      <!--         <input type="password" id='password'  v-model="password" placeholder="请输入密码">-->
      <!--         <input type="password" id="passwordAgain"  v-model="againPassword" placeholder="请再次输入密码">-->
    </div>
    <!-- <div class="login_info">
      <input type="text" placeholder="请输入用户名">
      <input type="text" placeholder="请输入密码">
    </div> -->
    <button class="register_submit" @click="submit">注册</button>
    <!-- </form> -->
  </div>
</template>
<script>
  import validate from '../lib/js/validata'
  import { setTimeout } from 'timers'

  export default {
    name: 'register',
    data() {
      return {
        phone: '',
        qrcode: '',
        againPassword: '',
        password: '',
        username: '',
        btncontent: '获取验证码',
        disableds: false,
        id: this.$utils.getUrlKey('id')
      }
    },
    created() {
      //console.log(validate.isPhone())
      // this.getId()
    },
    methods: {

      // 获取验证码
      buttonStatus() {
        let phonenumber = validate.isPhone(this.phone)
        if (!phonenumber.phoneStatus) {
          // console.log('请输入合法手机号');
          return
        }
         this.$createDialog({
            type: 'alert',
            content: '验证码已发送，请注意查收',
         }).show()

        let countdown = 60
        this.setTime(countdown)
        this.$http.api.phoneInfo({
          phone: this.phone
        }).then(result => {
          // console.log(result)
        })
      },
      setTime(countdown) {
        var _this = this
        if (countdown == 0) {
          this.disableds = false
          this.btncontent = '获取验证码'
          countdown = 60
          return
        } else {
          this.disableds = true
          this.btncontent = '重新发送(' + countdown + ')'
          countdown--
        }
        setTimeout(function () {
          _this.setTime(countdown)
        }, 1000)
      },
      submit() {
        // console.log(this.id)
        // let results = validate.isAllvalidate()
        if (!validate.isPhone(this.phone).phoneStatus) {
          return
        } else if (!validate.isqrCode(this.qrcode).qrCodeStatus) {
          return
        } else if (!validate.isUsername(this.username).UsernameStatus) {
          return
        }
        let _this = this
        // this.salesman_id = this.$utils.getUrlKey('user_id')
        // if (results.isall) {
        this.$http.api.register({
          name: this.username,
          phone: this.phone,
          password: this.password,
          input: this.qrcode,
          salesman_id: this.id
        }).then(result => {
          const toast = this.$createToast({
            txt: '注册成功',
            type: 'txt'
          }).show()
          // 跳转登录页面
          setTimeout(() => {
            // _this.$router.push('/')
            _this.$router.push({ name: 'index'})
          }, 500)

        })
        // }
      }
    },

    components: {}
  }
</script>
<style lang="less" scoped>
  .register_container {
    width: 100%;
    // height: 100;
    background: url('../assets/images/j-p1.jpg') top center no-repeat;
    background-size: cover;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    text-align: center;
    overflow: hidden;

    .register_imgLogo {
      width: 100%;
      text-align: center;
      margin-top: 35px;
      margin-bottom: 35px;

      img {
        width: 131px;
        margin: 0 auto;
      }
    }

    .register_info {
      margin: 0 auto;
      padding: 0 67px;
      text-align: center;
      border-radius: 5px;
      overflow: hidden;

      input {
        width: 100%;
        height: 50px;
        font-size: 12px;
        background: 0 0;
        border-bottom: 1px solid #b3daf2;
        color: #fff;
        padding-left: 10px;
      }

      ::-webkit-input-placeholder {
        color: rgba(255, 255, 255, .8)
      }

      ::-moz-placeholder {
        color: rgba(255, 255, 255, .8)
      }

      ::-ms-input-placeholder {
        color: rgba(255, 255, 255, .8)
      }

      .register_yzm {
        width: 100%;
        // height: 50px;
        border-bottom: 1px solid #b3daf2;
        text-align: center;
        overflow: hidden;

        input {
          width: 65%;
          float: left;
          border: none;
        }

        button {
          width: 80px;
          // height: 30px;
          font-size: 8px;
          margin-top: 14px;
          border: none;
          border-radius: 18px;
          background: #fff;
          line-height: 24px;
          outline: none;
          color: #61B0E3;
          float: right;
        }
      }
    }

    .register_submit {
      width: 241px;
      height: 38px;
      line-height: 38px;
      background: rgba(255, 255, 255, 1);
      border-radius: 19px;
      outline: none;
      border: none;
      color: #61B0E3;
      margin: 50px auto 0;
      font-size: 18px;
    }
  }
</style>
